module.exports = __webpack_public_path__ + "9779d9a1/img/settings-icon.121d9519.svg";